import { render, staticRenderFns } from "./infoWorkShift.vue?vue&type=template&id=25bad4d4&scoped=true&"
import script from "./infoWorkShift.vue?vue&type=script&lang=js&"
export * from "./infoWorkShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bad4d4",
  null
  
)

export default component.exports